import usePlatformMode from '@Hooks/usePlatformMode';
import api from '@Services/api';
import React from 'react';
import FamilyStatsTab from '../Components/FamilyStatsTab';
import PlatformLearningTime from '../Components/PlatformLearningTime';

/**
 * The three family tabs are configs over FamilyStatsTab. Row-click targets
 * only render when the destination family's flag is on, so the hub never
 * links into a route the platform mode has dropped.
 */

export const ClassroomsStatsTab: React.FC<{ instructorId?: number }> = ({ instructorId }) => {
	const { classroomsEnabled } = usePlatformMode();
	return (
		<FamilyStatsTab
			family="classrooms"
			entityLabel="Classroom"
			instructorId={instructorId}
			entityRoute={(row) =>
				classroomsEnabled && row.label
					? `/dashboard/classrooms/classroom/${row.label}/analytics`
					: null
			}
			// Parity with the retired all-classrooms page, which ended in the
			// platform-wide learning-time grid. Admin portal only — there is no
			// unscoped instructor time endpoint.
			footer={
				api.defaults.baseURL?.includes('/admin/') ? <PlatformLearningTime /> : undefined
			}
		/>
	);
};

export const StandaloneCoursesStatsTab: React.FC<{ instructorId?: number }> = ({
	instructorId,
}) => {
	const { standaloneEnabled } = usePlatformMode();
	return (
		<FamilyStatsTab
			family="standalone-courses"
			entityLabel="Course"
			instructorId={instructorId}
			showPrice
			showViaBundle
			revenueFootnote="Money from bundle purchases is reported under Bundles."
			entityRoute={(row) =>
				standaloneEnabled && row.label
					? `/dashboard/classrooms/standalone-courses/${row.label}/analytics`
					: null
			}
		/>
	);
};

export const BundlesStatsTab: React.FC<{ instructorId?: number }> = ({ instructorId }) => {
	const { bundlesEnabled } = usePlatformMode();
	return (
		<FamilyStatsTab
			family="bundles"
			entityLabel="Bundle"
			instructorId={instructorId}
			showPrice
			showCoursesCount
			entityRoute={(row) =>
				bundlesEnabled && row.label
					? `/dashboard/classrooms/bundles/${row.label}/analytics`
					: null
			}
		/>
	);
};
